import { z } from 'zod';

export const CreateLoteSchema = z.object({
  ambitoId: z.number().int().positive(),
  periodo: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  supervisorId: z.number().int().positive().optional(),
  ticketIds: z.array(z.number().int().positive()).min(1),
});

export const LoteStatusSchema = z.enum(['PENDIENTE', 'PARCIAL', 'COMPLETADO', 'EXPIRADO']);

export const LoteResponseSchema = z.object({
  id: z.number(),
  uuid: z.string().uuid(),
  ambitoId: z.number(),
  periodo: z.string(),
  supervisorId: z.number().nullable(),
  status: LoteStatusSchema,
  codigoVerificacion: z.string().regex(/^\d{6}$/),
  totalTickets: z.number().nonnegative(),
  ticketsAprobados: z.number().nonnegative(),
  ticketsRechazados: z.number().nonnegative(),
  linkUrl: z.string(),
  expiresAt: z.string().datetime(),
  completedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  // Email tracking (Resend webhooks) — emailResendId intentionally excluded (internal)
  emailSentAt: z.string().datetime().nullable(),
  emailDeliveredAt: z.string().datetime().nullable(),
  emailOpenedAt: z.string().datetime().nullable(),
  emailBouncedAt: z.string().datetime().nullable(),
});

export const LoteListFilterSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
  ambitoId: z.coerce.number().int().positive().optional(),
  periodo: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/).optional(),
  status: LoteStatusSchema.optional(),
});

export const SendLoteSchema = z.object({
  expiresInHours: z.number().int().min(1).max(168).default(72),
  supervisorId: z.number().int().positive(),
});

export const CreateAndSendLoteSchema = z.object({
  ambitoId: z.number().int().positive(),
  periodo: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  supervisorId: z.number().int().positive(),
  ticketIds: z.array(z.number().int().positive()).min(1),
  expiresInHours: z.number().int().min(1).max(168).default(72),
});

export type CreateLoteInput = z.infer<typeof CreateLoteSchema>;
export type CreateAndSendLoteInput = z.infer<typeof CreateAndSendLoteSchema>;
export type LoteResponse = z.infer<typeof LoteResponseSchema>;
export type LoteListFilter = z.infer<typeof LoteListFilterSchema>;
export type SendLoteInput = z.infer<typeof SendLoteSchema>;
